import { LocalizedElement } from '../i18n/Language';
import { LanguageSwitcher } from '../i18n/Language';
import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Link } from '../i18n/links';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { businessInfo } from '../mockData';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const currentPath = location.pathname.replace(/\/+$/, '') || '/';

  const navLinks = [
  { name: 'Home', path: '/' },
  { name: 'Services', path: '/#services' },
  { name: 'Vehicles', path: '/#vehicles' },
  { name: 'Locations', path: '/#locations' },
  { name: 'Blog', path: '/blog' },
  { name: 'About', path: '/about' },
  { name: 'Contact', path: '/contact' }];


  const isActive = (path) => {
    if (path === '/') return currentPath === '/';
    if (path.startsWith('/#')) return currentPath === '/';
    return currentPath === path.replace(/\/+$/, '');
  };

  return (
    <LocalizedElement as="header" className="bg-white shadow-md sticky top-0 z-50">
      {/* Top bar */}
      <LocalizedElement as="div" className="bg-blue-600 text-white py-2">
        <LocalizedElement as="div" className="container mx-auto px-4 flex justify-between items-center text-sm">
          <LocalizedElement as="div" className="flex items-center gap-4">
            <LocalizedElement as="a" href={`tel:+91${businessInfo.phone1}`} className="flex items-center gap-1 hover:text-blue-200 transition-colors">
              <Phone size={14} />
              <LocalizedElement as="span">{businessInfo.phone1}</LocalizedElement>
            </LocalizedElement>
            <LocalizedElement as="a" href={`mailto:${businessInfo.email}`} className="hidden md:flex items-center gap-1 hover:text-blue-200 transition-colors">
              <Mail size={14} />
              <LocalizedElement as="span">{businessInfo.email}</LocalizedElement>
            </LocalizedElement>
          </LocalizedElement>
          <LocalizedElement as="div" className="flex items-center gap-3">
            <LocalizedElement as="span" className="hidden xl:inline text-sm">Serving Since {businessInfo.established} | 24/7 Available</LocalizedElement>
            <LanguageSwitcher />
          </LocalizedElement>
        </LocalizedElement>
      </LocalizedElement>

      {/* Main header */}
      <LocalizedElement as="div" className="container mx-auto px-4 py-3">
        <LocalizedElement as="div" className="flex justify-between items-center">
          {/* Logo */}
          <LocalizedElement as={Link} to="/" className="flex items-center gap-3">
            <LocalizedElement as="img"
            src="/brand/logo-56.webp?v=badge-e75c0e4c89f4"
            srcSet="/brand/logo-56.webp?v=badge-e75c0e4c89f4 1x, /brand/logo-112.webp?v=badge-e75c0e4c89f4 2x, /brand/logo-168.webp?v=badge-e75c0e4c89f4 3x"
            alt="VVPSS Taxi Services logo"
            width="56"
            height="56"
            className="h-12 w-12 shrink-0 rounded-xl object-contain md:h-14 md:w-14"
            loading="eager"
            decoding="async" />

          </LocalizedElement>

          {/* Desktop Navigation */}
          <LocalizedElement as="nav" className="hidden lg:flex items-center gap-6">
            {navLinks.map((link) =>
            <LocalizedElement as={Link}
            key={link.path}
            to={link.path}
            className={`font-medium transition-colors hover:text-blue-600 ${
            isActive(link.path) ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-700'}`
            }>

                {link.name}
              </LocalizedElement>
            )}
          </LocalizedElement>

          {/* CTA Button */}
          <LocalizedElement as="div" className="hidden lg:block">
            <LocalizedElement as="a"
            href={`https://wa.me/91${businessInfo.whatsapp}`}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-blue-600 text-white px-6 py-2.5 rounded-lg font-medium hover:bg-blue-700 transition-all shadow-md hover:shadow-lg">

              Book Now
            </LocalizedElement>
          </LocalizedElement>

          {/* Mobile menu button */}
          <LocalizedElement as="button"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          className="lg:hidden text-gray-700 hover:text-blue-600 transition-colors p-1"
          aria-label={isMenuOpen ? 'Close navigation menu' : 'Open navigation menu'}
          aria-expanded={isMenuOpen}
          data-testid="mobile-menu-toggle">

            {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </LocalizedElement>
        </LocalizedElement>

        {/* Mobile Navigation */}
        {isMenuOpen &&
        <LocalizedElement as="nav" className="lg:hidden mt-4 pb-4 border-t pt-4">
            {navLinks.map((link) =>
          <LocalizedElement as={Link}
          key={link.path}
          to={link.path}
          onClick={() => setIsMenuOpen(false)}
          className={`block py-2 font-medium transition-colors hover:text-blue-600 ${
          isActive(link.path) ? 'text-blue-600' : 'text-gray-700'}`
          }>

                {link.name}
              </LocalizedElement>
          )}
            <LocalizedElement as="a"
          href={`https://wa.me/91${businessInfo.whatsapp}`}
          target="_blank"
          rel="noopener noreferrer"
          className="block mt-4 bg-blue-600 text-white px-6 py-2.5 rounded-lg font-medium text-center hover:bg-blue-700 transition-colors">

              Book Now
            </LocalizedElement>
          </LocalizedElement>
        }
      </LocalizedElement>
    </LocalizedElement>);

};

export default Header;
